import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { FieldValues, UseFormReturn, useForm } from 'react-hook-form';

type UseCustomerProfileFormReturn<T extends FieldValues> = {
  defaultValues: T | null;
  formMethods: UseFormReturn<T>;
};

export const useCustomerProfileForm = <T extends FieldValues>(
  getFormValues: () => Promise<T>,
): UseCustomerProfileFormReturn<T> => {
  // need default values for form because shouldUnregister: true delete all for not existing fields (problem with additional form)
  const [defaultValues, setDefaultValues] = useState<T | null>(null);

  const formMethods = useForm<T>({
    mode: 'all', // need to correct validate inbodId on load scan
    shouldUnregister: true, // delete also default values what not used
  });

  const getDefaultValues = async () => {
    const userData = await getFormValues();

    // We need to clone the object because hook form will mutate the original object
    setDefaultValues(cloneDeep(userData));

    formMethods.reset(userData);
  };

  useEffect(() => {
    getDefaultValues();
  }, []);

  return { defaultValues, formMethods };
};
